import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { VehicleAllocationRequestRecord } from 'src/app/models/vehicleAllocationRequestRecord';

@Component({
  selector: 'app-vehicle-reallocation-request-details',
  templateUrl: './vehicle-reallocation-request-details.component.html',
  styleUrls: ['./vehicle-reallocation-request-details.component.scss'],
  standalone: false
})
export class VehicleReallocationRequestDetailsComponent {

  @Input() requestItem: VehicleAllocationRequestRecord | null = null;
  @Input() isMobileApp = false;
  constructor(private readonly modalController: ModalController) { }

  async closeModal(): Promise<void> {
    await this.modalController.dismiss(
      { action: 'closed' },
      'close'
    );
  }
}
